//
//
//
//
//

import WaitTask from './WaitTask.vue';
    export default {
        components: {
           WaitTask
        },
    }
        



// WEBPACK FOOTER //
// ./src/pages/FinishTask.vue